import { useMutation } from "react-query";
import axios from "../axios";

const useForgotPassword = ({ onSuccess, onError }) => {
  const mutation = useMutation(
    async (params) => {
      return await axios.post("/api/auth/otp", {
        email: params.email,
      });
    },
    {
      onSuccess: (res) => onSuccess(res),
      onError: (err) => onError(err),
    }
  );

  return mutation;
};

export default useForgotPassword;
